import type { AppDispatch } from '../configure-store';
import { setTcfLoaded as setTcfLoadedAction } from './reducer';

// TCF = https://iabeurope.eu/transparency-consent-framework/
export const setTcfLoaded = () => (dispatch: AppDispatch) =>
    dispatch(setTcfLoadedAction());
